import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { AddRoleToPermitType, AddRoleToPermitTypeVariables } from "./__generated__/AddRoleToPermitType";

const ADD_ROLE_TO_PERMIT_TYPE = gql`
  mutation AddRoleToPermitType($organizationId: String!, $permitTypeId: String!, $orgRoleId: String!) {
    addRoleToPermitType(
      input: { organizationId: $organizationId, permitTypeId: $permitTypeId, orgRoleId: $orgRoleId }
    ) {
      permitTypeOrgRole {
        id
      }
    }
  }
`;

export function useAddRoleToPermitType() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    AddRoleToPermitType,
    AddRoleToPermitTypeVariables
  >(ADD_ROLE_TO_PERMIT_TYPE, { errorPolicy: "all" });

  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
